import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import setFilterQuery from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";

type HandlerType = HandlerWithResult<ProductFilters, ProductFilters>;

export const MergeParameter: HandlerType = props => {
    const currentFilters = cloneDeep(props.getState().pages.productList.productFilters);
    props.result = merge(currentFilters, props.parameter);
};

export const AbortOnDuplicateFilter: HandlerType = props => {
    const currentFilters = props.getState().pages.productList.productFilters;
    if (props.parameter.searchWithinQueries?.filter(x => currentFilters.searchWithinQueries?.includes(x)).length) {
        return false;
    }
};

export const ResetPage: HandlerType = props => {
    if (props.parameter.attributeValueIds?.length) {
        props.result.page = undefined;
    }
};

// Store Custom Code: Make sure filters are only added once
export const AddAttributeValueFilters: HandlerType = props => {
    const currentFilters = props.getState().pages.productList.productFilters;

    props.result.attributeValueIds = currentFilters.attributeValueIds;
    if (props.parameter.attributeValueIds) {
        if (!props.parameter.attributeValueIds.some(r => currentFilters?.attributeValueIds?.includes(r))) {
            props.result.attributeValueIds = props.parameter.attributeValueIds.concat(
                props.result.attributeValueIds || [],
            );
        }
    }
};

export const DispatchSetProductFilters: HandlerType = props => {
    props.dispatch({
        type: "Pages/ProductList/SetProductFilters",
        result: props.result,
    });
};

export const DispatchSetFilterQuery: HandlerType = props => {
    props.dispatch(setFilterQuery());
};

export const chain = [
    MergeParameter,
    AbortOnDuplicateFilter,
    AddAttributeValueFilters,
    DispatchSetProductFilters,
    DispatchSetFilterQuery,
];

const AddAttributeValueFiltersIfNotExist = createHandlerChainRunner(chain, "AddAttributeValueFiltersIfNotExist");
export default AddAttributeValueFiltersIfNotExist;
